import AddBoxIcon from '@mui/icons-material/AddBox'
import { DropAlert } from '../DropAlert'
import { DropPaper } from '../DropPaper'
import { StaticAttributeRow } from './StaticAttributeRow'
import MainButton from '../../common/util/input/MainButton'

export const StaticAttributesEditor = ({
    staticAttributes,
    setStaticAttributes,
    hasStaticAttributeErrors,
}) => {
    const addAttributeRow = () => {
        const tempStaticAttributes = [...staticAttributes]
        tempStaticAttributes.push({
            name: '',
            type: 'string',
            value: '',
        })
        setStaticAttributes(tempStaticAttributes)
    }

    return (
        <DropPaper
            error={hasStaticAttributeErrors()}
            id="StaticAttributesEditor"
        >
            <div className="text-2xl mb-5">Static Attributes</div>
            <div>
                Static Attributes are added to all assets that are created, and
                they are the same for every one. Common examples woud be{' '}
                <b>backImg</b>, <b>prevImg</b> or <b>description</b>. You can
                add them here if you like.
            </div>
            {staticAttributes.map((attribute, index) => (
                <StaticAttributeRow
                    attribute={attribute}
                    index={index}
                    staticAttributes={staticAttributes}
                    setStaticAttributes={setStaticAttributes}
                    key={'static_attribute' + index}
                />
            ))}
            <div className="flex justify-center mt-5">
                <div className="w-40">
                    <MainButton
                        fullWidth
                        startContent={<AddBoxIcon />}
                        onClick={() => addAttributeRow()}
                        isDisabled={hasStaticAttributeErrors()}
                    >
                        Add Attribute
                    </MainButton>
                </div>
            </div>
            <DropAlert severity="error" condition={hasStaticAttributeErrors()}>
                At least one attribute contains errors
            </DropAlert>
        </DropPaper>
    )
}
